angular.module('TetherApp').controller('ListManageController', [
    '$scope',
    '$window',
    'listService',
    'participantService',
    'participantClientMapService',
    function (
        $scope,
        $window,
        listService,
        participantService,
        participantClientMapService
    ) {

        let self = this;

        self.query = '';
        self.queryExisting = '';
        self.pagination = undefined;
        self.current_page = 1;
        self.allParticipants = {};
        self.existingListParticipants = {};
        self.currentListId = undefined;
        self.allLoadStatus = false;
        self.allPagination = {};
        self.existingPagination = {};
        self.existingLoadStatus = false;
        self.currentListId = undefined;
        self.selectedParticipants = [];
        self.currentSearchParticipants = [];
        self.currentExistingParticipants = [];
        self.selectedListParticipants = [];
        self.orderByField = 'first_name';
        self.orderByDirection = 'desc';
        self.orderByExistingField = 'first_name';
        self.orderByExistingDirection = 'desc';
        self.searchableFields = [
            'phone'
        ];

        self.getParticipantClientMapSortables = function() {
            participantClientMapService.getSortables()
                .then(onGetSortables, onError);
        };

        let onGetSortables = function (data) {
            if (data != undefined) {
                let tempArray = [];
                for (let index in data) {
                    tempArray.push(data[index]);
                }
                self.searchableFields = tempArray;
                self.orderByField = tempArray[0];
                self.orderByExistingField = tempArray[0];
                let cssHeightIE = parseInt(self.searchableFields.length) * 40;
                self.containerStyle = {'height' : cssHeightIE + 'px'};
                self.search();
            }
        };

        self.searchExistingParticipants = function (page) {
            let queryData = {};
            if (self.query != undefined && self.query != '') {
                queryData.query = self.query;
            }
            if (page != undefined && page != '') {
                queryData.page = page;
            }
            if (self.orderByField != undefined) {
                queryData.field = self.orderByField;
                queryData.direction = self.orderByDirection;
            }
            listService.searchExistingParticipants(self.currentListId, queryData)
                .then(onSearchExisting, onError);
        };

        let onSearchExisting = function (data) {
            self.existingListParticipants = data.data;
            self.currentExistingParticipants = [];
            self.existingListParticipants.forEach(function (participant) {
                self.currentExistingParticipants.push(participant.participant_id);
                if (participant.first_name == null) {
                    participant.first_name = '';
                }
                if (participant.last_name == null) {
                    participant.last_name = '';
                }
            });
            let pages = [];
            let firstNumber = ((data.current_page - 2) <= 0) ? 1 : data.current_page - 2;
            let lastNumber = firstNumber + 4;
            if (lastNumber > data.last_page) {
                lastNumber = data.last_page;
            }
            for(let i = firstNumber; i <= lastNumber; i++) {
                pages.push(i);
            }
            self.existingPagination = {};
            self.existingPagination.range = pages;
            self.existingPagination.total = data.total;
            self.existingPagination.current_page = data.current_page;
            self.existingPagination.last_page = data.last_page;
            self.existingPagination.next_page_url = data.next_page_url;
            self.existingPagination.prev_page_url = data.prev_page_url;
            self.existingPagination.from = data.from;
            self.existingPagination.to = data.to;
        };

        self.updateExistingListParticipants = function (listId, participant) {
            self.currentListId = listId;
            listService.addParticipantToList(listId, participant.id)
                .then(onUpdateExistingListParticipants, onError);
        };

        let onUpdateExistingListParticipants = function (data) {
            self.loadExistingParticipants(self.currentListId, 1);
        };

        self.removeParticipantFromList = function (listId, participantId) {
            self.currentListId = listId;
            listService.removeParticipantFromList(listId, participantId)
                .then(onRemoveParticipantFromList, onError);
        };

        let onRemoveParticipantFromList = function (data) {
            self.getParticipants(1);
            self.loadExistingParticipants(self.currentListId, 1);
        };

        self.loadExistingParticipants = function (listId) {
            if (self.currentListId == undefined) {
                self.currentListId = listId;
            }
            self.getParticipantClientMapSortables();
        };

        self.search = function () {
            self.getParticipants();
            self.searchExistingParticipants();
        };

        self.getParticipants = function (page) {
            let queryData = {};
            if (self.query != undefined && self.query != '') {
                queryData.query = self.query;
            }
            if (page != undefined && page != '') {
                queryData.page = page;
            }
            if (self.orderByField != undefined) {
                queryData.field = self.orderByField;
                queryData.direction = self.orderByDirection;
            }
            queryData.list_id = self.currentListId;
            participantService.getParticipants(queryData)
                .then(onGetParticipants, onError);
        };

        let onGetParticipants = function (data) {
            self.allParticipants = data.data;
            self.allParticipants.forEach(function (participant) {
                self.currentSearchParticipants.push(participant.id);
                if (participant.first_name == null) {
                    participant.first_name = '';
                }
                if (participant.last_name == null) {
                    participant.last_name = '';
                }
            });
            let pages = [];
            let firstNumber = ((data.current_page - 2) <= 0) ? 1 : data.current_page - 2;
            let lastNumber = firstNumber + 4;
            if (lastNumber > data.last_page) {
                lastNumber = data.last_page;
            }
            for(let i = firstNumber; i <= lastNumber; i++) {
                pages.push(i);
            }
            self.allPagination = {};
            self.allPagination.range = pages;
            self.allPagination.total = data.total;
            self.allPagination.current_page = data.current_page;
            self.allPagination.last_page = data.last_page;
            self.allPagination.next_page_url = data.next_page_url;
            self.allPagination.prev_page_url = data.prev_page_url;
            self.allPagination.from = data.from;
            self.allPagination.to = data.to;
        };

        self.updateOrderBy = function () {
            self.orderByDirection = (self.orderByDirection == undefined)
                ? 'asc':
                (self.orderByDirection == 'asc' ? 'desc' : 'asc');
        };

        self.updateOrderByExisting = function () {
            self.orderByExistingDirection = (self.orderByExistingDirection == undefined)
                ? 'asc':
                (self.orderByExistingDirection == 'asc' ? 'desc' : 'asc');
        };

        let onError = function(reason) {
            self.error = 'Could not fetch the data.';
        };

        self.toggleSelection = function (participantId) {
            let idx = self.selectedParticipants.indexOf(participantId);

            if (idx > -1) {
                self.selectedParticipants.splice(idx, 1);
            } else {
                self.selectedParticipants.push(participantId);
            }
        };

        self.toggleListSelection = function (participantId) {
            let idx = self.selectedListParticipants.indexOf(participantId);

            if (idx > -1) {
                self.selectedListParticipants.splice(idx, 1);
            } else {
                self.selectedListParticipants.push(participantId);
            }
        };

        self.addSelectedParticipants = function (listId) {
            listService.addParticipantsToList(listId, self.selectedParticipants)
                .then(onAddParticipantsToList, onError);
        };

        // self.addAllParticipants = function (listId) {
        //     listService.addParticipantsToList(listId, self.currentSearchParticipants)
        //         .then(onAddParticipantsToList, onError);
        // };

        let onAddParticipantsToList = function (data) {
            self.selectedParticipants = [];
            self.selectedListParticipants = [];
            self.query = '';
            self.loadExistingParticipants(self.currentListId);
        };

        self.removeSelectedListParticipants = function (listId) {
            listService.removeParticipantsFromList(listId, self.selectedListParticipants)
                .then(onRemoveParticipantsFromList, onError);
        };

        self.removeAllListParticipants = function (listId) {
            if ($window.confirm(self.deleteConfirmationText.replace(':number', self.currentExistingParticipants.length))) {
                listService.removeParticipantsFromList(listId, self.currentExistingParticipants)
                    .then(onRemoveParticipantsFromList, onError);
            }
        };

        let onRemoveParticipantsFromList = function (data) {
            self.selectedParticipants = [];
            self.selectedListParticipants = [];
            self.query = '';
            self.loadExistingParticipants(self.currentListId);
        };
    }
]);
